"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CURRENCY_MAP = {
    DE: '€',
    AT: '€',
    CH: 'CHF',
};
function convert(state) {
    return state.convert;
}
exports.convert = convert;
function convertPrice(state) {
    var convert = function (price) {
        if (state.convert && state.exchangeRates.EUR) {
            var exchangeRate = state.exchangeRates.EUR[CURRENCY_MAP[state.location]]
                ? state.exchangeRates.EUR[CURRENCY_MAP[state.location]].rate
                : 1;
            return price * exchangeRate;
        }
        return price;
    };
    return convert;
}
exports.convertPrice = convertPrice;
function currency(state) {
    var exchangeRate = state.exchangeRates.EUR[CURRENCY_MAP[state.location]]
        ? state.exchangeRates.EUR[CURRENCY_MAP[state.location]].rate
        : 1;
    return exchangeRate === 1 ? CURRENCY_MAP['DE'] : CURRENCY_MAP[state.location];
}
exports.currency = currency;
function location(state) {
    return state.location;
}
exports.location = location;
// export everything compliant to the vuex specification for getters
exports.default = {
    convert: convert,
    convertPrice: convertPrice,
    currency: currency,
    location: location,
};
//# sourceMappingURL=getters.js.map